<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import AdminLayout from '@/layouts/AdminLayout.vue'
import AuthLayout from '@/layouts/AuthLayout.vue'

// ---------------------------------------------------------------------------
// Layout resolution
// ---------------------------------------------------------------------------

const route = useRoute()

const layoutComponent = computed(() => {
  const layout = route.meta?.layout
  if (layout === 'AdminLayout') return AdminLayout
  return AuthLayout
})
</script>

<template>
  <div id="admin-app" class="min-h-screen bg-bg-primary text-text-primary font-sans">
    <component :is="layoutComponent" />
  </div>
</template>
